import { Button } from 'rsuite';
import { formatCurrencyToPtBr } from '../../../../../../../utils/currency';
import styles from './OfferDetailCell.module.scss';
import { IRowData } from './OfferTable';

interface OfferDetailCellProps {
  rowData: IRowData;
  onEdit: (rowData: IRowData) => void;
  disabled?: boolean;
}

const formatPercentageToPtBr = (value?: number) =>
  Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value ?? 0);

export const OfferDetailCell = ({ rowData, onEdit, disabled = false }: OfferDetailCellProps) => {
  if (!rowData.offer_dto?.offer) {
    return <section className={styles['offer-details']}>--</section>;
  }
  const offerTypeSelected = rowData.offer_dto.offer.offer_type;
  const formattedPercentageDiscount = formatPercentageToPtBr(rowData.offer_dto.offer.percentage_discount || 0);

  if (offerTypeSelected === 'SIMPLE_PRICE') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>{formatCurrencyToPtBr(rowData.offer_dto?.offer.offer_price || 0)}</div>

        <div className={styles['offer-type']}>
          <span>Oferta simples</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'SIMPLE_PERCENTAGE') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          {formattedPercentageDiscount}% de {formatCurrencyToPtBr(rowData.retail_price || 0)}
        </div>

        <div className={styles['offer-type']}>
          <span>% Desconto</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'FROM_TO') {
    const fromPrice = rowData.offer_dto.offer.from ?? rowData.retail_price;

    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          De {formatCurrencyToPtBr(fromPrice)} Por {formatCurrencyToPtBr(rowData.offer_dto?.offer.to || 0)}
        </div>

        <div className={styles['offer-type']}>
          <span>De/Por</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'BUY_PAY_QUANTITY') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          Leve {rowData.offer_dto?.offer.buy_quantity} pague {rowData.offer_dto?.offer.pay_quantity}
        </div>

        <div className={styles['offer-type']}>
          <span>Leve/Pague</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'BUY_GET_DISCOUNT') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          Leve {rowData.offer_dto?.offer.buy_quantity} e ganhe {formattedPercentageDiscount}% desconto
        </div>

        <div className={styles['offer-type']}>
          <span>Leve/Ganhe</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'UNIT_DISCOUNT') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          {formattedPercentageDiscount}% off na {rowData.offer_dto.offer.unit_buy}ªun
        </div>

        <div className={styles['offer-type']}>
          <span>Desconto na {rowData.offer_dto.offer.unit_buy}ªun</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'BULK_PERCENTAGE') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          A partir de {rowData.offer_dto?.offer.minimum_quantity}un ganhe {formattedPercentageDiscount}% desconto
        </div>

        <div className={styles['offer-type']}>
          <span>Desconto no Atacado</span>

          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  if (offerTypeSelected === 'BULK_PRICE') {
    return (
      <section className={styles['offer-details']}>
        <div className={styles['offer-value']}>
          A partir de {rowData.offer_dto?.offer.minimum_quantity}un pague {formatCurrencyToPtBr(rowData.offer_dto?.offer.price_per_unit || 0)}
        </div>

        <div className={styles['offer-type']}>
          <span>Oferta no Atacado</span>
          <Button appearance="link" onClick={() => onEdit(rowData)} disabled={disabled}>
            Editar
          </Button>
        </div>
      </section>
    );
  }

  return null;
};
